import { clickstreamLogger } from '~/logging';

const savedRegExps: Record<string, RegExp> = {};

interface RegExpMatchingConfig {
  property: string;
  pattern: string;
  flags?: string;
}

export const isMatchingRegExp = (
  node: Record<string, string>,
  configuration: RegExpMatchingConfig
) => {
  if (!configuration.pattern || !configuration.property) {
    clickstreamLogger.warn(
      'Invalid RegExp configuration: ',
      configuration
    );

    return false;
  }

  if (
    !node[configuration.property] ||
    typeof node[configuration.property] !== 'string'
  ) {
    return false;
  }

  const flags = configuration.flags ? configuration.flags : '';
  const fullPattern = `/${configuration.pattern}/${flags}`;

  if (savedRegExps[fullPattern] === null) {
    return false;
  }

  try {
    if (typeof savedRegExps[fullPattern] === 'undefined') {
      savedRegExps[fullPattern] = new RegExp(configuration.pattern, flags);
    } else {
      savedRegExps[fullPattern].lastIndex = 0;
    }

    return savedRegExps[fullPattern].test(node[configuration.property]);
  } catch (e) {
    clickstreamLogger.error(
      'Node property check with RegExp failed. RegExp config: ',
      configuration,
      '\n',
      e
    );
    savedRegExps[fullPattern] = null;

    return false;
  }
};

export const checkFullyVisible = (node: HTMLElement) => {
  // Если рассояние от верха плюс высота элемента помещается в видимой части экрана,
  // то считаем, что элемент виден полностью
  return (
    window.innerHeight >= node.getBoundingClientRect().top + node.clientHeight
  );
};
